import { useMemo } from 'react'
import { computeConquest } from './territoryUtils'
import { DOMINATION_SEATS_PER_MONTH } from './territories'

// Conquista de rutas a partir de los lobbies que ya trae el dashboard
// (/admin/lobbies). Recalcula cuando llegan datos nuevos o cambia el minuto,
// no en cada tic del reloj.
const useTerritories = (trips, nowMs) => {
  const minute = Math.floor(nowMs / 60000)
  return useMemo(
    () => ({ threshold: DOMINATION_SEATS_PER_MONTH, territories: computeConquest(trips, minute * 60000) }),
    [trips, minute]
  )
}

export default useTerritories
